// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__3qqnw","Label":"Input_Label__1X454","InputElement":"Input_InputElement__3HJ7B","Invalid":"Input_Invalid__1kqCq"};